export enum ValidationStatus {
  WIP = 'WIP',
  Valid = 'Valid',
  Invalid = 'Invalid',
}

export interface IValidateResult {
  field: string
  status: ValidationStatus
  text: string
}

export interface IControllerResult {
  status: ValidationStatus
  processes: (IValidateResult | null)[]
}
